/** *****************************************************************************
 * Licensed Materials - Property of IBM
 * (c) Copyright IBM Corporation 2024. All Rights Reserved.
 *
 * Note to U.S. Government Users Restricted Rights:
 * Use, duplication or disclosure restricted by GSA ADP Schedule
 * Contract with IBM Corp.
 ****************************************************************************** */

// copied from:
// https://github.ibm.com/ibmcloud/cloud-pal-community/blob/8adcdb05a31205b122067c1b649c525db8bf224d/src/components/Connected/RefResolverPicker/context/PickerContext.js

import React from 'react';
var PickerContext = /*#__PURE__*/React.createContext();
export default PickerContext;